import {configureStore, Tuple} from "@reduxjs/toolkit"
import {formErrorMiddleware} from "scholastic-client-components/src/middlewares/formErrorMiddleware"
import {getReduxMiddlewares} from "scholastic-client-components/src/middlewares/reduxMiddlewares"
import {rootReducer} from "./rootReducer"

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false, immutableCheck: false}).concat(
            new Tuple(...getReduxMiddlewares(), formErrorMiddleware.middleware)
        ),
})
